import { Link } from 'react-router-dom';

import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Typography, Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const TypographyTitle = styled(Typography)(
    ({ theme }: ParamsStyle) => `
    font-weight: 700;
    font-size: .875rem;
    color: ${theme?.palette.primary.light};
`);

export const Label = styled(Box)(
    ({ theme }: ParamsStyle) => `
        .title {
            font-size: .75rem;
            color: ${theme?.palette.grey[400]};
        }

        .description {
            font-size: 1rem;
            padding-top: .4rem;
            color: ${theme?.palette.primary.main};
        }
`);

export const ContentDetailsVehicles = styled.div(
    ({ theme }: ParamsStyle) => `
        display: block;
        padding-top: 1.18rem;
        justify-content: space-between;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: flex;
        }
`);

export const ContentCustomerCard = styled.div(
    ({ theme }: ParamsStyle) => `
        border: 2px solid ${theme?.palette.primary.main};
        border-radius: 5px;
        width: 9.5rem;
        height: 4.6875rem;
        display: flex;
        cursor: pointer;
        align-items: center;
        padding: 1rem 0 .5rem;
        flex-direction: column;
        justify-content: space-between;

        svg {
            max-width: 1.5625rem;
        }
`);

export const LinkButton = styled(Link)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    font-size: 1rem;
    font-weight: 600;
    height: 3.125rem;
    border-radius: 5px;
    align-items: center;
    margin-top: 1.1875rem;
    border: 1px solid #8D9BB5;
    padding: 4px 1rem 0 .625rem;
    justify-content: space-between;
    color: ${theme?.palette.primary.main};

    svg {
        height: 1.2rem;
        margin-bottom: 4px;
    }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);